var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.87748 10.2525C3.70123 10.08 3.59998 9.84747 3.59998 9.59997C3.59998 9.35247 3.70123 9.11997 3.87748 8.94747L10.4775 2.64747C10.8375 2.30247 11.4075 2.31747 11.7487 2.67747C12.09 3.03747 12.0787 3.60747 11.7187 3.94872L6.74623 8.69997H19.5C19.9987 8.69997 20.4 9.10122 20.4 9.59997C20.4 10.0987 19.9987 10.5 19.5 10.5H6.74623L11.7225 15.2475C12.0825 15.5925 12.0937 16.1587 11.7525 16.5187C11.4112 16.8787 10.8412 16.89 10.4812 16.5487L3.88123 10.2487L3.87748 10.2525Z",
    fill: "#1D5AB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.253cb0c6c6bb54ee17df172f60291603.svg";
export { ForwardRef as ReactComponent };